"use strict";

exports.__esModule = true;
exports["default"] = Box;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

var _styled = require("./styled");

var _propTypes = require("./propTypes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function Box(props) {
  return (0, _core.jsx)(_styled.BoxRoot, props);
}

Box.displayName = 'Box';
Box.propTypes = process.env.NODE_ENV !== "production" ? _propTypes.boxPropTypes : {};